import { FormProvider, useForm } from 'react-hook-form';
import { Trans, t } from '@lingui/macro';

import NgpTwoButtonDialog from '../../dialog-two-button/NgpTwoButtonDialog';
import NgpForm from '../../form/NgpForm';
import FormSection from '../../form/FormSection';
import { USE_FORM_DEFAULT_OPTIONS } from '../../../utilities/FormUtilities';
import NgpNumberField from '../../form/NgpNumberField';

const limitFormId = 'frmLimitDialog';
const sectionTitle = t`Set the limit of nPoints sending data to the ISNG`;
const limitFieldName = 'limit';
const limitHelpTip = t`Leaving this field blank is unlimited`;
const defaultValues = {};

export default function LimitDialog({ open, setOpen, onSave }) {
    const methods = useForm({ ...USE_FORM_DEFAULT_OPTIONS, defaultValues });
    const { handleSubmit, formState, reset } = methods;

    const handleCleanup = () => {
        reset(defaultValues);
    };

    const handleFormSubmit = ({ limit }) => {
        return onSave(limit || 0).then(handleCleanup);
    };

    return (
        <NgpTwoButtonDialog
            open={open}
            setOpen={setOpen}
            onConfirm={handleSubmit(handleFormSubmit)}
            onCloseFunc={handleCleanup}
            title={<Trans>Limit nPoints</Trans>}
            confirmButtonText={<Trans>Save</Trans>}
            cancelButtonText={<Trans>Cancel</Trans>}
            confirmButtonDisabled={!formState.isValid}
            callerWillCloseOnConfirm
            disableBackdropClick
        >
            <FormProvider {...methods}>
                <NgpForm
                    formId={limitFormId}
                    initialized
                    loading={false}
                    showSave={false}
                    formPadding={false}
                    showRequiredFieldsTip={false}
                    callerWillCloseOnConfirm
                    submitFunction={handleFormSubmit}
                >
                    <FormSection subText={sectionTitle}>
                        <NgpNumberField
                            fieldName={limitFieldName}
                            label={<Trans>Limit</Trans>}
                            min="1"
                            max="999999"
                            inputProps={{
                                size: 6,
                                maxLength: 6,
                            }}
                            helpTipText={limitHelpTip}
                        />
                    </FormSection>
                </NgpForm>
            </FormProvider>
        </NgpTwoButtonDialog>
    );
}
